import { logoutSUM } from '../../features/sum/sum.slice';
import { SUMRTKService } from '../services/sum-rtk.service';
import { resetSlice, store } from '../store';

export const SumSliceMiddleware = () => next => action => {
  if (SUMRTKService.endpoints.getEntity.matchRejected(action)) {
    const fullState = store.getState();
    const wizardId = fullState.bots?.wizard?.id;

    if (action.payload?.status === 401 || action.payload?.status == 400) {
      store.dispatch(logoutSUM({ id: wizardId }));
      localStorage.removeItem(`LB_SUM_token_${wizardId}`);
      resetSlice('sumRTK');
    }
  }

  return next(action);
};
